export const Icon = {
	ACCORDION: '100625',
	BUTTON: 'aC8ou51uob1J',
	COLUMNS: '52215',
	CTASection: '6916',
	DEFAULT: '87005',
	FORM: '2kp_j6sUhhNU',
	HEADER: '107431',
	HERO: '111028',
	IMAGE_TEXT_SECTION: 'cZzvUvXA72L5',
	LAYOUT: '62224',
	LINK: '85777',
	BRAGBAR: '5z2jE7WSK5w8',
	SECONDARY_HERO: '_0p37K42drxY',
	THANK_YOU: 'RZ686auD_5Wn',
	IMAGE: '57475',
} as const;

export type IconKey = keyof typeof Icon;
export type IconValue = (typeof Icon)[IconKey];
